import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CorporatePageShell from "../../../CommanComponents/CorporatePageShell";
import ProductActions from "../../../Redux/Actions/ProductActions";
import Slider from "react-slick";
import DeleteConfirmation from "../../../CommanComponents/Modals/DeleteConfirmation";
import { toast } from "react-toastify";
import {
  handleCategoryImageError,
  productImageUrl,
} from "../../../utils/landingUtils";

export default function ProductDetailsPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const productDetail = useSelector((state) => state.products.productDetail)?.product;
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    if (id) {
      dispatch(ProductActions.getProductById({ id }));
    }
  }, [id, dispatch]);

  const handleDelete = () => {
    if (productDetail?._id) {
      setIsDeleting(true);
      dispatch(ProductActions.deleteProduct(productDetail._id))
        .then((res) => {
          if (res) {
            toast.success("Product deleted successfully!");
            navigate("/corporate/products");
          } else if (res.status_code === 404) {
             toast.error("Product not found!");
          }
        })
        .finally(() => {
          setIsDeleting(false);
          setShowDeleteModal(false);
        });
    }
  };

  const sliderSettings = {
    dots: true,
    infinite: productDetail?.images?.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
    <CorporatePageShell
      title={productDetail?.name || "Product Details"}
      crumbLabel="Products"
    >
              <div className="service-detail-card3 product-slider">
                <Slider {...sliderSettings}>
                  {productDetail?.images?.map((image, index) => (
                    <div key={index} className="card-box">
                      <img
                        src={productImageUrl(image)}
                        onError={handleCategoryImageError}
                        alt={`Product ${index + 1}`}
                      />
                    </div>
                  ))}
                </Slider>
                <div>
                  <h3 className="text-capitalize">{productDetail?.name || ""}</h3>
                  <h4>{productDetail?.categoryId?.service_category_name}</h4>
                  <p>{productDetail?.description}</p>

                     {productDetail?.categoryId && (
                      <>
                      <h6 className="mb-1 mt-3">Category Details</h6>
                        <span>
                          Name: {productDetail.categoryId.name || "N/A"}
                        </span>
                        <span>
                          Description:
                          {productDetail.categoryId.description || "No description available."}
                        </span>
                      </>
                    )}
                  <div className="book-service-action-btn mt-3">
                    <button onClick={() => setShowDeleteModal(true)}>Delete</button>
                    <button
                      onClick={() =>
                        navigate(`/corporate/products/edit/${productDetail?._id}`)
                      }
                    >
                      Edit
                    </button>
                  </div>
                </div>
              </div>
    </CorporatePageShell>

        <DeleteConfirmation
          show={showDeleteModal}
          onHide={() => setShowDeleteModal(false)}
          onConfirm={handleDelete}
          title="Delete Product"
          message="Are you sure you want to delete this product?"
          confirmText="Delete"
          isLoading={isDeleting}
        />
    </>
  );
}